var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M48 20V76","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M20 48H76","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Plus.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = Plus;

Plus.default = Plus;
